
import { useEffect, useRef } from "react"

import { useDispatch, useSelector } from "react-redux"

import { BrowserRouter, Routes, Route } from "react-router"

import { RootState } from "../store"

import { login } from "../store/slices/AuthSlice"

import { PrivateRoute } from "./PrivateRoute"
import { ControlAccesoRoutes } from "./ControlAccesoRoutes"
import { PublicRoute } from "./PublicRoute"
import { AuthRoutes } from "./AuthRoutes "

export const AppRouter = () => {

    const dispatch = useDispatch();

    const token = useRef<String | null>(null);

    const { token: tokenRedux } = useSelector( ( state: RootState ) => state.auth );

    const data = window.localStorage.getItem("data");

    useEffect(() => {
        
        if( data ){

            dispatch( login( JSON.parse( data ) ) );

        } 
        else{            
            localStorage.removeItem('data');
            localStorage.removeItem('lastPath');
        }      

    }, [ data, dispatch ]); 

    if( data ){
        const dataJSON = JSON.parse( data );

        if( dataJSON ){
            token.current = dataJSON.token;
        }
    }
    else{
        token.current = tokenRedux ?? '';
    }

    return (

        <BrowserRouter>  

            <Routes>

                <Route path="/auth/*" element={ <PublicRoute token={ token.current } children={ <AuthRoutes /> } /> } />   

                <Route path="/*" element={ <PrivateRoute token={ token.current } children={ <ControlAccesoRoutes /> } /> } />       
            
            </Routes>
        
        </BrowserRouter>
    
    )
}